import type { DateOrRange } from '@/infrastructure/departure-date/store'
import { DepartureDateFilterComponent } from '@/scopes/search/components/DepartureDateFilter'
import {
  departureDateFilterOptionsSelector,
  isLoadingSelector,
} from '@/scopes/search/quick-search/components/selectors'
import { useQuickSearchSelector } from '@/scopes/search/quick-search/infrastructure/store/useQuickSearchSelector'
import * as React from 'react'

export function DepartureDateFilter({ onConfirm, onReset }: { onConfirm: ({ departureDate }: { departureDate: DateOrRange }) => void, onReset: () => void }) {
  const departureDateOptions = useQuickSearchSelector(departureDateFilterOptionsSelector)
  const isLoading = useQuickSearchSelector(isLoadingSelector)
  return (
    <DepartureDateFilterComponent
      id="departure-date-filter"
      onConfirm={onConfirm}
      onReset={onReset}
      disabled={isLoading || departureDateOptions.options.length === 0}
      options={departureDateOptions.options}
      biggerBreakpoint
    />
  )
}
